import React from 'react';

import { Elements, StripeProvider } from 'react-stripe-elements';
import ErrorReporter from 'app/components/ErrorReporter';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import StripeAPI from 'lib/StripeAPI';
import CoachingConstants from 'coaching/CoachingConstants';

type Props = {
  children: React.ReactNode;
  apiKey: string;
};

type State = {
  stripeLoaded: boolean;
  loadFailed: boolean;
};

export default class StripeContainer extends React.Component<Props, State> {
  state = {
    stripeLoaded: false,
    loadFailed: false,
  };

  componentDidMount() {
    StripeAPI.load().then(
      () => {
        this.setState({ stripeLoaded: true, loadFailed: false });
      },
      () => {
        this.setState({ stripeLoaded: true, loadFailed: true });
      }
    );
  }

  render() {
    const { apiKey } = this.props;

    if (!this.state.stripeLoaded) return <CenteredLoadingIndicator />;
    if (this.state.loadFailed)
      return (
        <ErrorReporter error="Error loading Stripe in the coaching StripeContainer">
          There was a problem loading this page. Please try again and contact{' '}
          {CoachingConstants.COACHING_HELP_EMAIL} if the problem persists.
          {this.props.children}
        </ErrorReporter>
      );
    return (
      <StripeProvider apiKey={apiKey}>
        <Elements>{this.props.children}</Elements>
      </StripeProvider>
    );
  }
}
